import React from 'react';

interface IProps {
  errors: string[];
}

const CdwTableErrors = ({ errors }: IProps) => {
  if (errors.length === 0) {
    return null;
  }
  return (
    <>
      {errors.map((err, ix) => (
        <div key={`err-${ix}`}>{err}</div>
      ))}
    </>
  );
};

export default CdwTableErrors;
